<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){ 
   //   console.log('PID：', this.$store.state.pid)
   }
}
</script>

<style lang="scss">
@import './assets/fonts/iconfont.css';
@import './assets/styles/style.scss';
.cursor{
  cursor: pointer;
}
.realtime_warning_scrollbar_container{
  height: calc(100vh - 300px);
  .el-scrollbar__wrap{
    overflow-x: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue